import { AvatarProps } from '@iveco-ti/iveco-ds'

export function colorAvatarByName(name: string): AvatarProps['color'] {
  const colors: AvatarProps['color'][] = ['default', 'success', 'danger']

  const index = name.charCodeAt(0) % colors.length

  return colors[index]
}
